// @flow
import React from "react";

import Selector from '../index';
import type { Props } from '../index'
import { useCriteres } from 'redux/hooks'


export default ({ value, onChange, ...props }: Props) => {

    const data = useCriteres();

    return (
        <Selector
            {...props}
            label="Sélection des critères"
            value={value}
            onChange={onChange}
            data={data}
        />
    )
};